import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import {vtmT} from '../../i18n';
import '../../../styles/vtm/roll.css';

/** Réglages de la campagne pour le MJ : nom, code d'invitation, archivage. Ouverts depuis l'en-tête. */
const VtmCampaignPanel = ({isOpen, onClose, campaign, onRename, onArchive}) => {
  const [name, setName] = useState(campaign.name || '');
  const [copied, setCopied] = useState(false);

  // Repartir du nom enregistré à chaque ouverture
  useEffect(() => {
    if (isOpen) setName(campaign.name || '');
  }, [isOpen, campaign.name]);

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(campaign.invitationCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      console.log(e);
    }
  };

  const archive = () => {
    onClose();
    onArchive();
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="vtmModal" overlayClassName="vtmModalOverlay" contentLabel={vtmT('campaignPanel')}>
      <div className="vtmModalHeader">
        <h2 className="vtmModalTitle">{vtmT('campaignPanel')}</h2>
      </div>
      <form className="vtmCampaignRename" onSubmit={event => { event.preventDefault(); if (name.trim()) onRename(name.trim()); }}>
        <label className="vtmCardLabelInline" htmlFor="vtmCampaignName">{vtmT('campaignName')}</label>
        <div className="vtmInlineControls">
          <input id="vtmCampaignName" type="text" value={name} onChange={event => setName(event.target.value)} />
          <button type="submit" className="vtmButton" disabled={!name.trim() || name.trim() === campaign.name}>{vtmT('rename')}</button>
        </div>
      </form>
      <div className="vtmCampaignCode">
        <span className="vtmCardLabelInline">{vtmT('invitationCode')}</span>
        <div className="vtmInlineControls">
          <code className="vtmInvitationCode">{campaign.invitationCode}</code>
          <button type="button" className="vtmButton ghost" onClick={copyCode}>{copied ? vtmT('copied') : vtmT('copy')}</button>
        </div>
      </div>
      <div className="vtmCampaignDanger">
        <button type="button" className="vtmButton danger" onClick={archive}>{vtmT('archiveCampaign')}</button>
      </div>
      <div className="vtmModalActions">
        <button type="button" className="vtmButton ghost" onClick={onClose}>{vtmT('close')}</button>
      </div>
    </Modal>
  );
};

export default VtmCampaignPanel;
